import type { FC, ReactNode } from 'react'

import { CwsH4, CwsAccordion, CwsAccordionItem, CwsAccordionItemBody, CwsAccordionItemHeader } from '@components/cws'
import s from './CategorySidePanel.module.scss'

interface SectionProps {
  title: string
  open?: boolean
  onHeadingClick?: (value: boolean) => any
  children?: ReactNode
}

export const Section: FC<SectionProps> = (props) => {
  const { title, children, open = false } = props

  return (
    <CwsAccordion size="medium" className={s.filter_section}>
      <CwsAccordionItem open={open} id={title}>
        <CwsAccordionItemHeader>
          <CwsH4 className="cws-my-10">{title}</CwsH4>
        </CwsAccordionItemHeader>
        <CwsAccordionItemBody>{children}</CwsAccordionItemBody>
      </CwsAccordionItem>
    </CwsAccordion>
  )
}
